  <section class="banner-inscripcion" *ngIf="info" id="banner-inscripcion">
    <div class="divimg">
      <img onerror="this.src='./assets/img/default.png'" class=" desk w-100 img-banner1"
        [src]="info.banner.imageBannerDeskPath">
      <img onerror="this.src='./assets/img/default.png'" class="mob w-100 mob img-banner1"
        [src]="info.banner.imageBannerMobilePath">
    </div>


    <div class="banner-texto  " id="banner-texto-1">
      <h2 id="banner1-texto1" class="nunito-medium" [style.color]="info.banner.bannerTextColor">
        {{info.banner.bannerText}}</h2>
      <h1 id="banner1-texto2" [style.color]="info.banner.subtitleBannerTextColor" class="nunito-medium">
        {{info.banner.subtitleBannerText}}</h1>
      <a [href]="info.banner.linkImageBanner" target="_blank" rel="noopener">
        <button id="banner-btn-1" class="btn-contacto nunito-medium zoomIn"
          [style.color]="info.banner.bannerButtonColor"
          [style.backgroundColor]="info.banner.backgroundBannerButton">{{info.banner.bannerButton}}</button>
      </a>

    </div>

  </section>
